<script>
    import Header from '../global/header.svelte'
    //import JsBarcode from 'jsbarcode'
    import { memberStore } from '../../store.js';
    import { onMount } from 'svelte';

    let user;
    let isFront = true;

    memberStore.subscribe(member => {
        user = member
    });

    function tapCardEvent() {

 
        if( isFront ) {
          
             dataLayer.push({
                'event':'CustomEvent',
                'category':'Membership Card Interactions',
                'action':'View Back',
                'label':'Click'
            })
         
            isFront = false;
        } else {
         
            dataLayer.push({
                'event':'CustomEvent',
                'category':'Membership Card Interactions',
                'action':'View Front',
                'label':'Click'
            });
         
            isFront = true;
        }

      

    }

    function orientationchange() {
    }

</script>

<svelte:head>
    <title>Customer Card</title>
</svelte:head>


<style>



label {
    -webkit-perspective: 1000px;
    perspective: 1000px;
    -webkit-transform-style: preserve-3d;
    transform-style: preserve-3d;
    display: block;
    width: 100%;
    height: 300px;
    
  
    cursor: pointer;
}

.card {
    margin: 10vh auto 5vh auto;
    border-radius: 20px;
    position: relative;
    height: 100%;
    width: 100%;
    -webkit-transform-style: preserve-3d;
    transform-style: preserve-3d;
    -webkit-transition: all 600ms;
    transition: all 600ms;
    z-index: 20;
    max-width: 554px;
    max-height: 362px;
}

.card .front p {
    position: absolute;
    top: 50%;
    z-index: 11;
    color: #000;
    margin: 0;
    line-height: 1.3;
    letter-spacing: 2px;
    margin-left: 5%;
    text-align: left;
}

.card .logo {
    position: absolute;
    top: 10%;
    left: 5%;
    z-index: 11;
}

.back {
    display: flex;
    align-items: center;
    justify-content: center;
}

.card footer {
    position: absolute;
    bottom: -10px;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 8% 5%;
    z-index: 11;
}
.card .front span {
    letter-spacing: 0px;
    font-weight: 500;
    text-align: left;
}

.card .front:after {
    content: '';
  
    position: absolute;
    top: 0;
    right: 0;
    background: url('../card/honeycomb.png') 0 0 no-repeat;
}

.card div {
    overflow: hidden;
    position: absolute;
    height: 100%;
    width: 100%;
    background: #fff;
    text-align: center;
    line-height: 200px;
    -webkit-perspective: 0;
    -webkit-backface-visibility: hidden;
    -webkit-transform: translate3d(0,0,0);
    visibility:visible;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    border-radius: 10px;
}

 .logo {
        max-width: 45%;
    }

     .logo-l {
          max-width: 35%;
     }

      .logo-r {
          max-width: 55%;
     }

@media screen and ( max-width: 400px ) {

    .card {
        max-width: 320px;
        max-height: 200px;
    }

   
     .card .front:after {
         width: 136px;
         height: 168px;
         background-size: 136px 168px;
     }

}

@media screen and ( min-width: 401px ) and ( max-width: 560px ) {

    .card {
        max-width: 390px;
        max-height: 240px;
    }

   

     .card .front:after {
         width: 174px;
         height: 207px;
         background-size: 174px 207px;
     }

}

@media screen and ( min-width: 561px ) {

    .card {
        max-width: 565px;
        max-height: 320px;
    }

   
     .card .front:after {
         width: 213px;
         height: 255px;
         background-size: 213px 255px;
     }

     .card .front p {
         font-size: 18px;
         font-size: 1.8rem;
     }
}



.card .back {
    background: #fff;
    color: #FFF;
    -webkit-transform: rotateX(180deg);
    transform: rotateX(180deg);
    z-index: 111;
}


input {
    display: none;
}

:checked + .card {
    transform: rotateX(180deg);
    -webkit-transform: rotateX(180deg);
}

label:hover :checked + .card {
    transform: rotateX(180deg);
    -webkit-transform: rotateX(180deg);
    box-shadow: 0 20px 20px rgba(255,255,255,.2);
}
h1 {
    text-align: center;
    color: var(--brand-color);
    font-size: 40px;
    font-size: 4.0rem;
    font-weight: 300;
}

</style>

<svelte:window on:resize={orientationchange}/>

<Header title="My virtual card" url="/" /> 

<section>
    <div>
      
        <label>
            <input type="checkbox"  />
            <div class="card"  on:click={tapCardEvent} >
                <div class="front">
                    <img src="card/logo.svg" alt="logo" class="logo"> 
                    <p>{user.number}<br/><span>{user.name}</span></p>
                    <footer>
                        <img src="card/logo-footer.svg" alt="Card base" class="logo-l"> 
                        <img src="card/logo-footer-r.svg" alt="Card base" class="logo-r"> 
                    </footer>
                </div>
                <div class="back">
                  <img style="max-width:90%" alt="Card number" src="https://barcodes.southernco-op.co.uk/?bc={user.number.trim()}" />
                  <!-- <canvas id="barcode"></canvas>  -->
                </div>
            </div>
        </label>


        <h1>Tap card<br/>to turn over</h1>

    </div>
</section>
